<template>
    <div class="container" v-title="'注销账户'">
        <Navigation-bar></Navigation-bar>
        <div class="container_content">
            <Title title="注销账户" subtitle="需验证你的手机号"></Title>
            <div id="Unsubscribe" >
                <div class="content">
                    <ul>
                        <li>
                            <div class="item-input">
                                <input type="text" disabled :value="textEncryption(form.phone, 3, 4, '****')" style="background:#FAFAFA;color: #747576">
                            </div>
                        </li>
                        <li>
                            <div class="item-input">
                                <input type="tel" pattern="\d*" :class="{'error' : form.codeHint}" v-model="form.code" @blur="codeBlur()" maxlength="6" placeholder="请输入验证码">
                                <span v-if="!form.codeDisabled" class="text-btn" :class="UserType == 1?'s':'c'" @click="sendCode()">获取验证码</span>
                                <span v-else class="text-btn" style="color: #1B1C1E;" v-text="countDownText"></span>
                            </div>
                            <p class="errorHint" v-text="form.codeHint"></p>
                        </li>
                    </ul>
                </div>
                <div class="operation">
                    <button @click="send()">注销</button>
                </div>
            </div>
        </div>
        <Alert-tip :tipData="alertTip" :tipShow="tipShow" @closeCallback="tipShow = false"  @btnCallback="btnCallback"></Alert-tip>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
    SendVerificationCodeForUserCloseAccount,
    UserCloseAccount
} from "@/api"
import {
    closeWebView,
    resetToken
} from "@js/appInteraction"
import {
    textEncryption
} from '@js';
export default {
    name:"Unsubscribe",
    data(){
        return {
            form:{
                phone:"",
                code:"",
                codeHint:"",
                codeDisabled:false,
            },
            VerificationSerialNumber:"",
            token:"",
            countDown: 0,
            timer: null,
            alertTip:{
                title:"温馨提示",
                text:"账户注销后将无法登录，您的身份信息、账户信息、赛事信息将被清空且无法恢复",
                btnArr:["取消","注销"]
            },
            tipShow:false
        }
    },
    created(){
        if(this.$store.state.UserInfo.MobileNumber){
            let MobileNumber = this.$store.state.UserInfo.MobileNumber;
            this.form.phone = MobileNumber;
        }
    },
    beforeDestroy(){
        clearInterval(this.timer);
    },
    computed:{
        ...mapGetters(['UserType']),
        countDownText:function(){
            return this.countDown ? this.countDown + "s" : "";
        }
    },
    watch:{
        "form.code":function(){
            this.form.codeHint = ""; 
            if(this.form.code.length > 6){
                this.form.codeHint = "验证码错误"; 
            }
        }
    },
    methods:{
        textEncryption,
        codeBlur(){
            if(this.form.code.length != 6){
                this.form.codeHint = "验证码错误";
                return false;
            }
        },
        sendCode(){
            SendVerificationCodeForUserCloseAccount({
                MobileNumber: this.form.phone
            }).then(data=>{
                if(data.Code == 0){
                    this.VerificationSerialNumber = data.VerificationSerialNumber;
                    this.countDown = 60;
                    this.form.codeDisabled = true;
                    clearInterval(this.timer);
                    this.timer = setInterval(() => {
                        this.countDown--;
                        if(this.countDown <= 0){
                            this.form.codeDisabled = false;
                            clearInterval(this.timer);
                        }
                    }, 1000);
                }
            })
        },
        send(){
            if(this.codeBlur() == false){
                this.$Toast('请完成号码验证','error');
                return ;
            }
            this.tipShow = true;
        },
        btnCallback(text){
            this.tipShow = false;
            if(text == '注销'){
                this.$Toast('正在注销','loading');
                UserCloseAccount({
                    MobileNumber: this.form.phone,
                    VerificationSerialNumber: this.VerificationSerialNumber,
                    InputVerificationCode: this.form.code
                }).then(data=>{
                    if(data.Code == 0){
                        this.$Toast('注销成功','success');
                        setTimeout(()=>{
                            resetToken({UserType:0});
                            closeWebView(2);
                        },1000)
                    }
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
#Unsubscribe{
    .content{
        max-height: 632px;
        min-height: 400px;
        height: 70%;
        padding: 40px 40px 0;
        box-sizing: border-box;
        ul{
            li{
                width: 670px;
                margin: 0 auto;
                margin-bottom: 32px;
                .item-input{
                    width: 670px;
                    height: 112px;
                    position: relative;
                    input{
                        width: 100%;
                        height: 100%;
                        background: #F9F9F9;
                        border-radius: 20px;
                        padding: 0 32px;
                        font-size: 32px;
                        box-sizing: border-box;
                        &.error{
                            background: rgba(240,110,67,0.1);
                        }
                    }
                    .text-btn{
                        @include line-height(40px);
                        font-size: 28px;
                        font-weight: 500;
                        text-align: right;
                        position: absolute;
                        right: 32px;
                        top: 50%;
                        margin-top: -20px;
                        &.s{
                            color: #7AD21A;
                        }
                        &.c{
                            color: #FFA61C;
                        }
                    }
                }
                .errorHint{
                    @include line-height(40px);
                    font-size: 28px;
                    font-weight: 400;
                    color: #F06E43;
                    margin-top: 8px;
                }
            }
        }
    }
    .operation{
        height: 92px;
        width: 100%;
        margin-top: 80px;
        button{
            @include btn-type-large;
            background: #F5F7F5;
            color: #1B1C1E;
        }
    }
}
</style>